import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'Martín G.',
  city: 'Rosario'
}, {
  name: 'Diego L.',
  city: 'Buenos Aires'
}, {
  name: 'Sebastián M.',
  city: 'Córdoba'
}, {
  name: 'Nicolás F.',
  city: 'Mar del Plata'
}, {
  name: 'Alejandro V.',
  city: 'Mendoza'
}, {
  name: 'Juan P.',
  city: 'Bariloche'
}, {
  name: 'Carlos R.',
  city: 'Salta'
}, {
  name: 'Fernando T.',
  city: 'Tucumán'
}, {
  name: 'Lucas S.',
  city: 'La Plata'
}];
export function SocialProofPopup() {
  const [currentBuyer, setCurrentBuyer] = useState<{
    name: string;
    city: string;
  } | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const timeoutsRef = useRef<number[]>([]);
  const clearAllTimeouts = () => {
    timeoutsRef.current.forEach(id => clearTimeout(id));
    timeoutsRef.current = [];
  };
  const addTimeout = (callback: () => void, delay: number) => {
    const id = window.setTimeout(callback, delay);
    timeoutsRef.current.push(id);
    return id;
  };
  useEffect(() => {
    addTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearAllTimeouts();
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    addTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      addTimeout(showNextBuyer, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-202">
      {isVisible && currentBuyer && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white text-slate-900 p-4 rounded-lg shadow-2xl border-l-4 border-green-500 flex items-center gap-3 max-w-[300px]" data-id="element-203">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-204">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-205" />
          </div>
          <div data-id="element-206">
            <p className="text-sm font-medium leading-tight" data-id="element-207">
              <span className="font-bold" data-id="element-208">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs text-slate-500 mt-1" data-id="element-209">
              acaba de comprar Charter Command System™
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}